<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <h6>Inventario</h6>

            <div class="row align-items-end">
              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar producto..." @input="fetchData(null)" />
              </div>
              <div class="col-md-8 mb-3 text-end">
                <button type="button" class="btn btn-sm btn-outline-warning me-2 mb-1" @click="openGoldPriceModal"
                  data-toggle="tooltip" data-original-title="Aplicar valor del oro por gramo a productos con precio por gramos">
                  <i class="fa fa-coins me-1"></i> Valor oro por gramo
                </button>
                <button type="button" class="btn btn-sm btn-outline-primary me-2 mb-1" @click="exportExcel"
                  :disabled="isExporting">
                  <i class="fa fa-download me-1"></i> Descargar Excel
                </button>
                <router-link :to="{ name: 'Supplies Create' }" class="btn btn-sm btn-primary ms-2 mb-1"
                  data-toggle="tooltip" data-original-title="Agregar inventario">
                  <i class="fa fa-plus me-1"></i> Agregar inventario
                </router-link>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Stock
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Precio de venta
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Semáforo
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Última modificación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.ref }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value.quantity }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value.selling_price != null && value.selling_price !== '' ? parseFloat(value.selling_price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-danger': value.quantity <= value.low,
                        'bg-gradient-warning': value.quantity <= value.medium,
                        'bg-gradient-success': value.quantity >= value.medium,
                      }">
                        {{
                          value.quantity >= value.high
                            ? 'Alto'
                            : value.quantity > value.low
                              ? 'Medio'
                              : 'Bajo'
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        :class="value.status == 1 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ value.status == 1 ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <a @click="syncWordPress(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        :class="{ 'opacity-50': syncingWordPressId === value.id }"
                        data-toggle="tooltip" data-original-title="Actualizar stock en WordPress">
                        <i class="fa" :class="syncingWordPressId === value.id ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></i>
                      </a>
                      <router-link
                        :to="{ name: 'Supplies Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs ms-2" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>
                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="8" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Modal valor oro por gramo -->
    <div class="modal fade" id="ModalGoldPrice" tabindex="-1" aria-labelledby="goldPriceModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="goldPriceModalLabel">Valor del oro por gramo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="text-sm text-secondary mb-3">
              Se actualizará el <strong>precio de venta</strong> de todos los productos que tengan marcado &quot;El precio de venta se calcula por gramos&quot;, usando: <em>Precio de venta = Precio por gramo del producto × Valor del oro por gramo</em>.
            </p>
            <div class="mb-3">
              <label for="goldValuePerGram" class="form-label">Valor del oro por gramo</label>
              <input type="number" step="0.01" min="0" v-model.number="goldValuePerGram" id="goldValuePerGram"
                class="form-control" placeholder="Ej: 150000" />
            </div>
            <div class="mb-3">
              <label for="goldCategorySelect" class="form-label">Categoría a aplicar</label>
              <select id="goldCategorySelect" class="form-select" v-model="goldCategory">
                <option value="">Todas las categorías</option>
                <option v-for="category in categories" :key="category.id" :value="String(category.id)">
                  {{ category.fullname || category.name }}
                </option>
              </select>
              <small class="text-muted">
                Si no selecciona categoría, se aplicará a todos los productos por gramos.
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            <button type="button" class="btn btn-warning" @click="applyGoldPrice" :disabled="isApplyingGoldPrice || goldValuePerGram === '' || Number(goldValuePerGram) < 0">
              <span v-if="isApplyingGoldPrice"><i class="fa fa-spinner fa-spin me-1"></i> Aplicando...</span>
              <span v-else><i class="fa fa-check me-1"></i> Aplicar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      isExporting: false,
      goldPriceModal: null,
      goldValuePerGram: '',
      isApplyingGoldPrice: false,
      syncingWordPressId: null,
      goldCategory: '',
      categories: [],
    };
  },
  computed: {
    ...mapGetters('inventory', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.inventory.currentPage;
    },
    lastPage() {
      return this.$store.state.inventory.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['inventory/links'];
    },
  },
  methods: {
    async getCategories() {
      const response = await this.$store.dispatch('categories/getCategories');
      const list = response?.data || [];
      this.categories = list.sort((a, b) => {
        const fullnameA = a.fullname || a.name || '';
        const fullnameB = b.fullname || b.name || '';
        return fullnameA.localeCompare(fullnameB);
      });
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('inventory/fetchData', params);
    },
    async exportExcel() {
      if (this.isExporting) return;
      this.isExporting = true;
      try {
        const response = await this.$store.dispatch('inventory/exportExcel', this.searchQuery || null);
        const blob = new Blob([
          response.data,
        ], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'inventario.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        await Swal.fire('Listo', 'Archivo Excel descargado correctamente.', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'Error al exportar el Excel',
        });
      } finally {
        this.isExporting = false;
      }
    },
    openGoldPriceModal() {
      this.goldValuePerGram = '';
      this.goldCategory = '';
      this.$nextTick(() => {
        const el = document.getElementById('ModalGoldPrice');
        if (!this.goldPriceModal) this.goldPriceModal = new Modal(el);
        this.goldPriceModal.show();
      });
    },
    async syncWordPress(row) {
      if (!row.ref || row.ref.trim() === '') {
        await Swal.fire({
          icon: 'warning',
          title: 'Sin referencia (SKU)',
          text: 'Este producto no tiene referencia. Agregue una en la ficha del producto para sincronizar con WordPress.',
        });
        return;
      }
      this.syncingWordPressId = row.id;
      try {
        const response = await this.$store.dispatch('inventory/syncWordPress', row.id);
        const data = response?.data || response;
        await Swal.fire({
          icon: 'success',
          title: 'WordPress',
          text: data?.message || 'Stock actualizado en WordPress.',
        });
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message || 'Error al sincronizar con WordPress.';
        await Swal.fire({ icon: 'error', title: 'WordPress', text: msg });
      } finally {
        this.syncingWordPressId = null;
      }
    },
    async applyGoldPrice() {
      const value = Number(this.goldValuePerGram);
      if (value === '' || isNaN(value) || value < 0) {
        await Swal.fire({ icon: 'warning', title: 'Ingrese un valor válido (número ≥ 0).' });
        return;
      }
      this.isApplyingGoldPrice = true;
      try {
        const response = await this.$store.dispatch('inventory/applyGoldPrice', {
          valuePerGram: value,
          category: this.goldCategory,
        });
        const data = response?.data || response;
        const count = data?.updated_count ?? 0;
        if (this.goldPriceModal) this.goldPriceModal.hide();
        await Swal.fire({
          icon: 'success',
          title: 'Listo',
          text: data?.message || 'Precios actualizados. Productos actualizados: ' + count,
        });
        this.fetchData();
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message || 'Error al aplicar el valor.';
        await Swal.fire({ icon: 'error', title: 'Error', text: msg });
      } finally {
        this.isApplyingGoldPrice = false;
      }
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('inventory/delete', userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error('Error al eliminar el registro:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
  },
  mounted() {
    this.getCategories();
    this.fetchData();
  },
  beforeUnmount() {
    if (this.goldPriceModal) this.goldPriceModal.dispose();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>
